module.exports = __webpack_public_path__ + "static/media/security_image.3435bb82.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/security_image.png
// module id = 490
// module chunks = 0